
const API_VERSIONS = Object.freeze({
  V1: 'application/json',
  V2: 'application/vnd.5a.v2+json',
});

export const v2Header = () => ({
  Accept: API_VERSIONS.V2,
});
